module.exports = __webpack_public_path__ + "static/media/66bd2988-77f9-42ec-bc0b-6757820def8c.c588e917.JPG";